import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  initials: 'MG',
  name: 'Mariela G.',
  location: 'Córdoba',
  quote: 'Armé mi primer catálogo en una tarde y esa misma semana vendí mis primeros 5 frasquitos. Nunca pensé que iba a ser tan fácil arrancar.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Rosario',
  quote: 'Los +500 mensajes del Tomo 2 son extraordinarios. Mis clientas me dicen que el rollito que sacaron ese día era exactamente lo que necesitaban escuchar.'
}, {
  initials: 'CS',
  name: 'Carmen S.',
  location: 'Buenos Aires',
  quote: 'Con las respuestas listas para el cliente de WhatsApp cerré mi primer pedido en menos de 10 minutos. El sistema realmente funciona.'
}];
export function TestimoniosQuick() {
  return <section className="py-12 bg-brand-base px-4 border-t border-white/5 pt-[4px] pb-[4px]" data-id="element-276">
      <div className="max-w-6xl mx-auto" data-id="element-277">
        <p className="text-sm font-bold text-gray-500 tracking-widest uppercase mb-8" data-id="element-278">
          Testimonios
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-279">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white/5 backdrop-blur-sm p-6 rounded-2xl border border-white/10 flex flex-col items-center" data-id="element-280">
              <div className="flex gap-1 mb-3 text-yellow-400 justify-center" data-id="element-281">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-282" />)}
              </div>
              <p className="text-gray-300 italic mb-4 text-sm leading-relaxed" data-id="element-283">
                "{t.quote}"
              </p>
              <div className="flex flex-col items-center gap-2 mt-auto" data-id="element-284">
                <div className="w-12 h-12 rounded-full bg-brand-green text-white flex items-center justify-center font-bold" data-id="element-285">
                  {t.initials}
                </div>
                <div data-id="element-286">
                  <p className="font-bold text-sm text-white" data-id="element-287">{t.name}</p>
                  <p className="text-xs text-gray-400" data-id="element-288">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}